import { http, HttpResponse } from "msw";
import { lookupGithubAccount } from "@/Shared/Helpers/githubAccounts";

/**
 * Stand-in for the GitHub users API the People team form calls from the browser, so stories and
 * mock mode never reach the real one. The accounts are invented to match the synthetic People
 * fixtures; anything else is a 404, which is how GitHub answers an unknown username or a deleted
 * account's id. `1000002` is listed on the synthetic member but not here, so their profile shows
 * the deleted-account state.
 */
const MOCK_GITHUB_ACCOUNTS = [
  { id: 1000001, login: "avery-stone" },
  { id: 1000003, login: "priya-nair" },
];

export const githubHandlers = [
  http.get("https://api.github.com/user/:githubId", ({ params }) => {
    const account = MOCK_GITHUB_ACCOUNTS.find(
      (candidate) => String(candidate.id) === params["githubId"],
    );
    return account
      ? HttpResponse.json(account)
      : HttpResponse.json({ message: "Not Found" }, { status: 404 });
  }),
  http.get("https://api.github.com/users/:login", ({ params }) => {
    const login = String(params["login"]).toLowerCase();
    const account = MOCK_GITHUB_ACCOUNTS.find(
      (candidate) => candidate.login === login,
    );
    return account
      ? HttpResponse.json(account)
      : HttpResponse.json({ message: "Not Found" }, { status: 404 });
  }),
];

/**
 * Answers the lookups the synthetic People fixtures and the GitHub accounts stories need before
 * any story renders. The snapshot harness captures a page once its own data is in, without
 * waiting for further requests; the GitHub lookups start only after that data arrives, so without
 * this a snapshot would catch them mid-flight on some runs and finished on others.
 */
export function preloadMockGithubLookups(): Promise<unknown> {
  return Promise.all(
    [
      "id:1000001",
      "id:1000002",
      "id:1000003",
      "login:priya-nair",
      "login:priya-nairr",
    ].map(lookupGithubAccount),
  );
}
